import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { ConfirmDialogService } from '../../service/common/dialog/confirm-dialog.service';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take } from 'rxjs/operators';
import { KontaktdatenService } from '../../service/kontaktdaten/kontaktdaten.service';
import { Kontaktdaten } from '../../domain/model/kontaktdaten';
import { KontaktItem } from '../../domain/model/kontakt-item';

@Component({
    selector: 'redispatch-settings-kontaktdaten-detail',
    templateUrl: './settings-kontaktdaten-detail.component.html',
    styleUrls: [
        './settings-kontaktdaten-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsKontaktdatenDetailComponent implements OnInit {
    public kontaktdaten: Kontaktdaten = new Kontaktdaten();
    public createNew: boolean = false;

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private kontaktdatenService = inject(KontaktdatenService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private confirmDialogService = inject(ConfirmDialogService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        const kontaktdatenId = this.activatedRoute.snapshot.queryParams['kontaktdaten'];
        this.createNew = kontaktdatenId == null || kontaktdatenId === '';
        if (kontaktdatenId) {
            this.kontaktdatenService.getKontaktdaten(kontaktdatenId)
                .pipe(take(1))
                .subscribe((kontaktdaten: Kontaktdaten) => {
                    this.kontaktdaten = kontaktdaten;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    saveKontaktdaten() {
        // clean up KontaktItems
        const cleanedUpKontakte: KontaktItem[] = [];
        this.kontaktdaten.kontakte.forEach(function (ki) {
            if ((ki.data && ki.data.trim().length > 0) || (ki.type && ki.type.trim().length > 0)) {
                cleanedUpKontakte.push(ki);
            }
        });
        this.kontaktdaten.kontakte = cleanedUpKontakte;

        if (this.createNew) {
            this.kontaktdatenService.createKontaktdaten(this.kontaktdaten).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Kontaktdaten wurde erfolgreich angelegt');
            });
        } else {
            this.kontaktdatenService.saveKontaktdaten(this.kontaktdaten).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Kontaktdaten wurde erfolgreich gespeichert');
            });
        }
    }

    async deleteKontaktdaten(kontaktdaten: Kontaktdaten) {
        if (await this.confirmDialogService.confirm(
            'Beachten Sie, dass wenn Sie fortfahren, sowohl der Kontaktdaten, als auch alle bestehenden Zuordnungen ' +
            'zu Netzbetreibern entfernt werden. Dieser Vorgang kann nicht rückgängig gemacht werden.',
            'Kontaktdaten entfernen!',
            'warn',
            'Entfernen',
        )) {
            this.kontaktdatenService.deleteKontaktdaten(kontaktdaten).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Kontaktdaten wurde entfernt');
            });
        }
    }

    addKontakt() {
        this.kontaktdaten.kontakte.push(new KontaktItem('', ''));
    }
}
